import {getDaysText} from "./utils/common";
import {ActivityType} from "./utils/consts";
import dayjs from "dayjs";

export const PresetDateValue = {
  TODAY: `Сегодня`,
  TOMORROW: `Завтра`,
  MONDAY: `Понедельник`,
  NEXT_MONTH: `Следующий месяц`,
  NO_TIME_LIMIT: `Без срока`,
};

export const deadline = (flatpickr) => {
  const deadlineWrapperElement = document.querySelector(`.js-deadline-wrap`);
  const DEADLINE_INPUT_NAME = `deadline`;
  const DeadlineInputValue = {
    LIMIT: `time-limit`,
    NO_LIMIT: `no-time-limit`,
  };

  if (deadlineWrapperElement) {
    const daysToDeadlineElement = deadlineWrapperElement.querySelector(`.js-deadline-days`);
    const changeDayModalElement = deadlineWrapperElement.querySelector(`.js-modal-change-date`);

    // Добавление datepicker
    const fp = flatpickr(`.js-flatpicker`, {
      altInput: true,
      altFormat: "D, j M",
      dateFormat: "Y-m-d",
      monthSelectorType: "static",
      minDate: "today",
      static: true,
    });

    const setDateToDeadline = (date) => {
      const days = Math.ceil((new Date(`${date}`) - new Date()) / 1000 / 60 / 60 / 24);

      daysToDeadlineElement.textContent = getDaysText(days);

      if (days < 0) {
        daysToDeadlineElement.classList.add(`deadline__days--burn`);
      } else {
        daysToDeadlineElement.classList.remove(`deadline__days--burn`);
      }
    };

    const setDateFromPreset = (presetValue) => {
      let date;
      switch (presetValue) {
        case PresetDateValue.TODAY:
          date = new Date();
          break;
        case PresetDateValue.TOMORROW:
          date = dayjs().add(1, `day`).toDate();
          break;
        case PresetDateValue.MONDAY:
          date = dayjs().day(8).toDate();
          break;
        case PresetDateValue.NEXT_MONTH:
          date = dayjs().month(dayjs().month() + 1).date(1).toDate();
          break;
      }

      fp.setDate(date);
      setDateToDeadline(date);
    };

    const setActivityChangeDayModal = (type) => {
      switch (type) {
        case ActivityType.SHOW:
          changeDayModalElement.classList.add(`modal--show`);
          break;
        case ActivityType.HIDE:
          changeDayModalElement.classList.remove(`modal--show`);
          break;
      }
    };

    const onDayModalClick = (evt) => {
      evt.stopPropagation();
      const target = evt.target;

      if (target.classList.contains(`modal__change-day`)) {
        setDateFromPreset(target.textContent.trim());
        setActivityChangeDayModal(ActivityType.HIDE);
      }
    };

    const onDaysToDeadlineElementClick = (evt) => {
      evt.stopPropagation();

      if (changeDayModalElement.classList.contains(`modal--show`)) {
        setActivityChangeDayModal(ActivityType.HIDE);
        return;
      }

      setActivityChangeDayModal(ActivityType.SHOW);
    };

    const onWindowClick = (evt) => {
      if (changeDayModalElement.classList.contains(`modal--show`)) {
        setActivityChangeDayModal(ActivityType.HIDE);
      }
    };

    if (fp.element) {
      fp.config.onChange.push(function(selectedDates, dateStr, instance) {
        setDateToDeadline(dateStr);
      });
    }

    const deadlineRadioInputElement = document.querySelector(`.js-deadline-radio`);
    const form = deadlineRadioInputElement.form;

    const deadlineDateInputs = form.querySelectorAll(`.js-flatpicker`);
    const isoDate = new Date().toISOString().slice(0, 10);

    const init = () => {
      switch (form[DEADLINE_INPUT_NAME].value) {
        case DeadlineInputValue.NO_LIMIT:
          deadlineDateInputs[0].disabled = true;
          deadlineWrapperElement.classList.add(`deadline__date-wrap--not`);
          break;
        case DeadlineInputValue.LIMIT:
          deadlineDateInputs[0].disabled = false;

          if (!deadlineDateInputs[1].value) {
            const currentDate = deadlineDateInputs[0].value ? deadlineDateInputs[0].value : isoDate;

            if (deadlineDateInputs[0].value !== currentDate) {
              deadlineDateInputs[0].value = currentDate;
            }

            deadlineDateInputs[1].value = dayjs(currentDate).format("dd, D MMM").replace(`.`, ``);

            setDateToDeadline(currentDate);
          }

          deadlineWrapperElement.classList.remove(`deadline__date-wrap--not`);
          break;
      }
    };

    init();

    deadlineRadioInputElement.form.addEventListener(`change`, init);
    daysToDeadlineElement.addEventListener(`click`, onDaysToDeadlineElementClick);
    changeDayModalElement.addEventListener(`click`, onDayModalClick);
    window.addEventListener(`click`, onWindowClick);
  }
};
